module.exports = __webpack_public_path__ + "img/szkola.99ec8863.jpg";